import React, { useState, useEffect, useContext } from 'react';
import TransactionTable from '../reports/components/TransactionListCard.jsx/TransactionTable';
import { Context } from '../../utils/context'

import { startOfMonth, endOfMonth, subMonths, parseISO, format } from 'date-fns';
import { Tab, Tabs } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import ExternalTransactionTable from '../reports/components/TransactionListCard.jsx/ExternalTransactionTable';
import ExternalTransactionTableV2 from '../reports/components/TransactionListCard.jsx/ExternalTransactionTableV2';

const TransactionTableWrapper = () => {
    const { id } = useParams();
    const { axios, authData, permissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`

    const [loading, setLoading] = useState(false)
    const [transactionType, setTransactionType] = useState(0)
    const [cardId, setCardId] = useState(null)
    const [masterTransaction, setMasterTransactions] = useState([])
    const [externalTransaction, setExternalTransactions] = useState([])
    const [start_date, setStartDate] = useState(subMonths(startOfMonth(new Date()),2))
    const [end_date, setEndDate] = useState(endOfMonth(new Date()))
    const [total_data, setTotalData] = useState(1)
    const [pagination, setPagination] = useState({
        limit:20,
        offset:0
    })

    useEffect(() => {
        const onInitData = async() => {
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                const cardholder_rq = await axios.get(`/cardholder/${id}`)
                setCardId(cardholder_rq.data.data.idCard)
            } catch (error) {
                
            }
        }
        onInitData()
    }, [])

    useEffect(() => {
        const onRequestData = async() => {
            setLoading(true)
            const {offset, limit} = pagination
            try {
                axios.defaults.headers.common['Authorization'] = authToken
                //let transTypes = '7000'
                let params = {idCardholder:id}

                const _start_date = start_date.toISOString()
                const _end_date = end_date.toISOString()

                if(transactionType === 0){
                    const transactions_request = await axios.get(`/report/transaction/${offset*limit}/${limit}/${_start_date}/${_end_date}`, {params:{...params}})
                    setTotalData(transactions_request.data.data.totalRegistries)
                    let _transactions_data = [...transactions_request.data.data.registries]
                    setMasterTransactions(_transactions_data)
                }else{
                    params = {idCard:cardId}
                    const transactions_request = await axios.get(`/report/event/${offset*limit}/${limit}/${_start_date}/${_end_date}`, {params:{...params}})
                    console.log(transactions_request)
                    console.log(transactions_request.data.data)
                    setTotalData(transactions_request.data.data.totalRegistries)
                    let _transactions_data = [...transactions_request.data.data.registries]
                    setExternalTransactions(_transactions_data)
                }
                // Activation Data
                
                


            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        if(cardId) onRequestData()
    },[start_date, end_date, pagination, transactionType, cardId])


    const onChangeTab = (event, newValue) => {
        let _pag = {...pagination}
        _pag.offset = 0
        setPagination(_pag)
        setTransactionType(newValue)
    }

    return ( 
        <div>
            <Tabs
                value={transactionType}
                indicatorColor="primary"
                textColor="primary"
                onChange={onChangeTab}
            >
                <Tab label="FLEXIA TRANSACTIONS" />
                <Tab label="EXTERNAL TRANSACTIONS"  />
            </Tabs>
            <div style={{marginTop:16}}>
                {transactionType === 0 
                ? <TransactionTable loading={loading} data={masterTransaction} total={total_data} tableFilter={pagination} onUpdateTableFilter={(_data) => setPagination(_data)} />
                :<ExternalTransactionTableV2 loading={loading} data={externalTransaction} total={total_data} tableFilter={pagination} onUpdateTableFilter={(_data) => setPagination(_data)} />}
            </div>
        </div>
     );
}
 
export default TransactionTableWrapper;